import { AuthenticationFailed, PermissionLevel } from 'gleblu-socket-api';
import { createReducer } from 'redux-act';

import { accountDeleted } from '@/store/actions/authentication/deleteAccount';

import LoggedInUser from '../../models/interfaces/LoggedInUser';
import { authenticationRequired } from '../actions/authentication/authenticationRequired';
import { loggedInUserFetched } from '../actions/authentication/fetchLoggedInUser';
import { loginFailed, loginSuccessful } from '../actions/authentication/login';
import { logout } from '../actions/authentication/logout';
import { placeAdded } from '../actions/place/addPlace';

export interface AuthenticationState {
  readonly token: string;
  readonly loggedInUser: LoggedInUser | null;
  readonly authenticationFailed: AuthenticationFailed | null;
}

const defaultState: AuthenticationState = {
  token: '',
  loggedInUser: null,
  authenticationFailed: null,
};

const authenticationReducer = createReducer<AuthenticationState>({}, defaultState);

authenticationReducer.on(loginSuccessful, (state, { token }) => ({ ...state, token }));

authenticationReducer.on(loginFailed, (state, { authenticationFailed }) => ({ ...state, authenticationFailed }));

authenticationReducer.on(loggedInUserFetched, (state, { loggedInUser }) => ({ ...state, loggedInUser }));

authenticationReducer.on(authenticationRequired, (_) => ({ token: '', loggedInUser: null, authenticationFailed: null }));

authenticationReducer.on(logout, (_) => ({ token: '', loggedInUser: null, authenticationFailed: null }));

authenticationReducer.on(accountDeleted, (_) => ({ token: '', loggedInUser: null, authenticationFailed: null }));

authenticationReducer.on(placeAdded, (state, { placeName }) => {
  if (state.loggedInUser == null) return state;
  return {
    ...state,
    loggedInUser: {
      ...state.loggedInUser,
      placePermissions: [
        ...state.loggedInUser.placePermissions,
        {
          uuid: '',
          userUuid: state.loggedInUser.userUuid,
          placeUuid: placeName.uuid,
          reservationPermission: PermissionLevel.edit,
          settingPermission: PermissionLevel.edit,
        },
      ],
    },
  };
});

export default authenticationReducer;
